import { Pricings } from '~/composables/types/event'

export const getPricingTotalPrice = (pricing: Pricings) => {
  return pricing.price.total_price
}

export const getPricingAppliedDiscount = (pricing: Pricings) => {
  return pricing.price.applied_discount
}

export const getPricingBasePrice = (pricing: Pricings) => {
  return pricing.price.base_price
}

export const getPricingPricePerPerson = (pricing: Pricings, title: string) => {
  return pricing.price_breakdown.find((item) => item.title === title)
    ?.price_per_person
}
